
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { reduxForm, change } from 'redux-form';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';

import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';
import detectMobileBrowsers from '../../../helpers/detectMobileBrowsers';
import messages from '../../../locale/messages';
import history from '../../../core/history';
import { searchFormSuggestSelect, changeSearchForm } from '../../../helpers/GeoSuggest/updateSearchForm';
import { setPersonalizedValues } from '../../../actions/personalized';
import searchIcon from '/public/SiteIcons/searchIconHome.svg';

import s from './LocationSearchForm.css';
import bt from '../../commonStyle.css';
class LocationSearchForm extends React.Component {
  static propTypes = {
    personalized: PropTypes.shape({
      location: PropTypes.string,
      lat: PropTypes.number,
      lng: PropTypes.number,
      chosen: PropTypes.number,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      formatMessage: PropTypes.any,
    }),
    settingsData: PropTypes.shape({
      listSettings: PropTypes.array.isRequired
    }).isRequired
  };

  static defaultProps = {
    listingFields: []
  };

  static defaultProps = {
    personalized: {
      location: null,
      lat: null,
      lng: null,
      startDate: null,
      endDate: null,
      chosen: null
    },
    settingsData: {
      listSettings: []
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      mobileDevice: false,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields } = nextProps;
    if (listingFields != undefined) {
      this.setState({
        roomType: listingFields.roomType
      });
    }
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    if (detectMobileBrowsers.isMobile() === true) {
      this.setState({ mobileDevice: true });
    }
    if (listingFields != undefined) {
      this.setState({
        roomType: listingFields.roomType
      });
    }
  }

  handleClick = () => {
    const { personalized } = this.props;
    let updatedURI, uri = '/s?';

    if (personalized.chosen != null) {
      uri = uri + '&address=' + personalized.location + '&chosen=' + personalized.chosen;
    } else {
      if (personalized.location != null) {
        uri = uri + '&address=' + personalized.location;
      }
    }
    updatedURI = encodeURI(uri);
    history.push(updatedURI);
  }

  onSuggestSelect = (data, value) => {
    const { setPersonalizedValues } = this.props;
    searchFormSuggestSelect({ data, setPersonalizedValues, value });
  }

  onChange = async (value) => {
    const { setPersonalizedValues, change } = this.props;
    if (value == '') {
      changeSearchForm({ setPersonalizedValues, change });
    }
  }

  render() {
    const { personalized } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <form>
        <div className={cx(s.searchFormContainer, 'searchFormContainerDark', 'locationInputContainer', 'layoutOneLocationSearch')}>
          <PlaceGeoSuggest
            placeholder={formatMessage(messages.homeWhere)}
            className={cx(s.serchInput, 'newGeoSuggestDark', s.inputPadding, 'searchFormContainer')}
            initialValue={personalized?.location}
            onChange={this.onChange}
            onSuggestSelect={this.onSuggestSelect}
            id={'locationSearch'}
            containerClass={cx(s.searchInputContainer, 'geoSuggestLayout1')}
          />
          <div className={cx(s.searchBtnContainer, 'searchBtnContainerAr')}>
            <Button className={cx(bt.btnPrimary, s.btnBlock, s.btnLarge)} onClick={this.handleClick}>
              <img src={searchIcon} className={cx(s.searchIconCommon, 'searchIconCommonTwoRTL')} />
              <span className={'hidden-xs'}>
                <FormattedMessage {...messages.search} />
              </span>
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

LocationSearchForm = reduxForm({
  form: 'SearchForm', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(LocationSearchForm);

const mapState = (state) => ({
  personalized: state?.personalized,
  settingsData: state?.viewListing?.settingsData,
  listingFields: state?.listingFields?.data,
});

const mapDispatch = {
  setPersonalizedValues,
  change
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(LocationSearchForm)));
